export enum SalesType {
  LEAD = 'LEAD',
  CONTRACT = 'CONTRACT',
}
